import { Dispatch, SetStateAction } from "react";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import { MainImage } from "../workDetailPage/WorkMainImage";
import Navigator from '../components/Navigation';
import { WorkFullImage } from "../workDetailPage/WorkFullImage";
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { ArticleMainImage } from "../articleDetailPage/ArticleMainImage";
import image1 from '../image/articles/article4-1.webp';
import image2 from '../image/articles/article4-2.webp';
import image3 from '../image/articles/article4-3.webp';
import article3MainImage from '../image/articles/article3-1.webp';
import ProtectedPage from "../components/ProtectedPage";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Divider } from "@mui/material";
import { Wavedivider } from "../components/Wavedivider";
import { QuoteBlock } from "../components/QuoteBlock";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";

function Article4(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
      const images2 = [image2]; 
      const images3 = [image3];
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ARTICLE4_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ARTICLE4_SECTION_PASSWORDS
      );
      useMetaTags({
        title: '25.10. 회고 - Lynkim',
        description: "Life's lines of closeness / 몰입하는 시간  /  일의 태도 / 당근 4주년",
        image: '/ogimage.png',
      });
      
      return (
        <>
        <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요">
          <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
          <div className='fadeIn '>
            <ArticleTitle
              title={'25.10. 회고'}
              titleEn={'25.10. Retrospective'}
              description={<div>Life's lines of closeness / 몰입하는 시간  /  일의 태도 / 당근 4주년</div>}
              descriptionEn={<div>Life's lines of closeness / Time spent in flow / Attitude toward work / Daangn's 4th anniversary</div>}
              category={'essay'}
              date={'2025.10.31.'}
              thumbnail={image1}/>
          </div>
          <Wavedivider/>
          <div className='articleLayout'>
            <ArticleTextSection
                title = '프롤로그'
                subTitle = {<div>Life's lines of closeness</div>}
                description= {<div>
                    이번 달 가장 인상깊었던 그림. <br/> 
                    단순한 선 뿐인데 뭉클하다. </div>}
            />
            
            <ArticleImageLayout images={images3} />
            <CalloutLink href="https://www.instagram.com/drawingolive">
            Life's lines of closeness - by Olivia de Recat   /   @drawingolive
            </CalloutLink>

            <ArticleTextSection 
                
                title = '몰입하는 시간'
                description=
                  {<div>
                    이번 달은 긴 추석 연휴로 휴식으로 시작했다. 추석연휴가 되기 전에 계획한 일들이 있고, 하루하루를 보내면서 어떤 것에 시간을 썼는지 캘린더에 표시를 하며 연휴를 보냈다. 초반에는 하고자 하는 것이 많았는데, 그동안 쌓인 피로가 몰려와서 거의 대부분의 시간을 아무것도 하지 않은채 그저 잠을 자고, 쉬고, 놀면서 보냈다. 하지만 피로가 많이 누적되었다는 것을 알아서, 그렇게 시간을 흘려보내는 것에서 죄책감을 느끼지는 않고 오히려 만족하며 시간을 보냈던 것 같다. 
                    <br/><br/>
                    근 3년간은 명절에 더이상 본가로 내려가지 않았기 때문에, 긴 연휴에 아무 곳도 가지 않고 항상 집에서만 홀로 시간을 보냈다. 연휴에 서울에 있으면 카페도 음식점도 거의 열지 않고, 거리도 한산해서 항상 텅빈 도시에 홀로 고립된 느낌이 들었다. 이 상황이 나에게 외로움을 크게 느끼게 만들어서 명절 연휴가 다가오면 항상 어떤 것에 몰입하며 외로움을 잊을지 계획했고, 연휴가 그리 유쾌하지 않았다. 
                    <br/><br/>
                    이번 연휴는 꽤나 만족스러웠다. 
                    집에서 푹쉬면서 피로를 풀 수 있었고, 생각보다 몰입이 잘되어서 생산적으로 시간을 사용했다는 것에 만족감도 들었고, 무엇보다 본가에 내려가지 않아도 어머니가 나에게 불쾌함을 갖지 않을 것이라는 것을 이제는 알아서 심리적으로 불편함이 없어서가 컸다.
                    <br/><br/>
                    이번 연휴동안 얼마전까지 집중해서 진행한 프로젝트에 대해 포트폴리오도 완성했고, 디자인에 대해서도 공부하고, 관심갔던 주제에 대해서도 공부했고, 읽고 싶은 소설도 읽고, 보고싶었던 예능도 봤다. 
                    항상 이렇게 시간을 사용하면 매일이 꽤나 행복할 것 같다는 생각을 했고, 이를 지키기 위해서는 내가 하고 싶어하는 것들에 방해없이 집중할 수 있는 시간을 마련하는 것이 중요하겠다는 생각을 했다.
                    <br/><br/>
                  </div>} 
                marginBottom={true}
            />
            <ArticleImageLayout images={images2} />
            <ProtectedArticleGroup
                lockPassword={sectionLockHashes}
                description="이 글은 무슨 내용일까요?"
            >
            <ArticleTextSection 
                marginTop={true}
                title = '일의 태도'
                description=
                  {<div>
                    새로운 팀에 합류한지 4개월쯤이 되어서 함께 일하는 팀원들간 가치관의 차이가 있다는 것을 점점 느끼고 있다. 나와 협업하는 것이 힘들다고 하는 것을 전해들었고, 팀이 다소 딱딱하고 일하는게 하드하다고 느낀다는 회고도 들었고, 나에게 더 회사원이 아닌 스타트업처럼 일했으면 좋겠다는 의견을 주기도 했다. 
                    <br/><br/>
                    나도 사실 요즘 팀원들을 대할 때, 이전 팀과 다르게 진심으로 즐겁게 이야기를 나누지 않고 그저 웃고 있는 가면을 쓰고 대하고 있다. 솔직하게 지금 일하는 태도를 보면 정말 월급을 받고 일하는 회사원의 태도가 맞다. 그저 맡은 역할에 최선을 다하지만, 점심시간에 적극적으로 사람들과 친해지기 위해 시간을 쓰지 않고 오로지 나의 휴식을 위해 시간을 쓰고 있고, 자리에 앉아 열띄게 토론을 하는 것보다 혼자만의 집중을 위해 자리를 피하고, 메신서로 필요한 소통을 하기를 기대한다. 내 시간에 맞춰 출근하고, 내 시간에 맞춰 퇴근한다. 위법한 행동이 아니라고 생각해서 문제가 되지 않을 것이라고 생각했지만, 일하는 태도가 다른 사람들에게는 그대로 비춰졌을 것이고, 그 행동이 회사의 가치관과 맞지 않아 불편감을 주었을 수도 있을 것 같다. 
                    <br/><br/>
                    회사보다는 너무 나의 삶에 집중하고, 내가 하고 싶은 것에만 몰입하며 살아왔던 것 같다. 그러다보니 조금의 요청에도 거부감을 느끼고 굉장히 벽을 쳤다고 생각한다. 내가 우리 회사와 가치관이 맞지 않는다면 이 회사를 빠르게 떠나는게 좋을까 고민을 했는데, 그런 태도는 어떤 회사도 원하지 않을 것이라는 말을 들었고, 그 말에 동의한다. 
                    <br/><br/>
                    함께 일하는 사람들과 나를 위해서라도 내가 조금은 더 바뀔 필요가 있다. 그래도 주기적으로 팀원들과 점심시간을 함께 보내면서 이야기를 하고, 조금은 내 일보다 회사 일에 시간을 더 써보기로.  
                  </div>} 
                // marginBottom={true}
            />
            </ProtectedArticleGroup>
            <ArticleTextSection 
                marginTop={true}
                title = '당근 4주년'
                description=
                  {<div>
                    당근에서 일을 한게 벌써 4주년이 되었다. 분명 2년 쯤 되었을 때 딱 1년만 더 다니자 다짐했는데, 그 시간이 결국엔 4년이 되어버릴 줄이야. 2년정도 되었을 때쯤 이직을 고민하며, 회사에서 제시한 현금성 보상은 그냥 안받은 셈치고 3년이 되면 꼭 이직을 하자고 다짐했는데, 그 돈이 생각보다 마음의 짐이 될 줄은 몰랐다. 
                    <br/>4주년이 되었다는 말에 한 5~6년 쯤 된 사람들이 하나같이 4년된 거 축하할 일 맞을까요? 라고 했는데, 그 말에 참 공감한다. 사실 이렇게 4주년을 맞이한게, 어쩌면 나태하고 안주한 결과로도 볼 수 있지 않을까.
                    <br/><br/>
                    하지만 그보다도 사실 당근에서 지낸 지난 1년이 생각보다 너무 좋았어서 그 기억에 1년을 더 다니게 되었고, 이래저래 회사에서 새로운 일도 맡으며 시간이 지겹지 않게 빠르게 지나간 것도 있다. 주변에 인생에 오래 남아줄 친구도 많이 생기고, 일 뿐 아니라 인생을 함께 살아갈 사람들이 많이 생겼다는 것이 회사에서 얻은 가장 큰 선물인 것 같다.  
                    
                    <br/><br/>지난 1년 동안 어떤 것이 가장 기억에 남았는가 생각해보면, 내가 1년 사이에 경제적으로 많은 여유를 느끼게 되었다는 것, 여유가 있고 마음이 안정되니 더 큰 도전에 대한 열망이 생각보다 빠르게 식었다는 것, 항상 그 시절 모두가 꿈은 꾸지만 결국 그렇게 다 똑같이 회사원으로 살아가게 될거라는 어른들의 말이 틀린것 하나 없었다는 것.
                    <br/><br/> 하지만 그럼에도 여전히 언젠가는 도달해있지 않을까 하는 꿈을 꾸고, 또 한번 시도해보고, 다시 열망을 가져보기도 하는 것처럼, 아직은 꿈을 놓지 않고, 도약할 에너지를 모으고 있는 것 아닐까!
                      
                    </div>} 
                 marginBottom={true}
            />
            
          </div>    
          
          <NextItem to='/Article3' thumbnail={article3MainImage} nextProjectTitle='25.09. 회고'/>

          <BackButton/>
          </ProtectedPage>
        </>
      )
  }
  
  export default Article4;
